'use strict';

var portfolioModule = angular.module("app.portfolioModule", []);


portfolioModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider: ng.ui.IStateProvider, $locationProvider: angular.ILocationProvider) {

        console.log('app.portfolioModule config...');

        $stateProvider
            .state("dashboard",
            {
                url: "/dashboard",
                templateUrl: "assets/templates/portfolioSummary/dashboard.html",
                controller: 'portfolioDashboardCtrl',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Dashboard"};
                  }],
                }
            })
            .state("portfolioHeatmap",
            {
                url: "/portfolioHeatmap",
                templateUrl: "assets/templates/portfolioSummary/portfolioHeatmap.html",
                controller: 'portfolioHeatmapCtrl',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Heatmap"};
                  }],
                }
            })
            .state("portfolioSnapshot",
            {
                url: "/portfolioSnapshot",
                templateUrl: "assets/templates/portfolioSummary/portfolioSnapshot.html",
                controller: 'portfolioSnapshotCtrl',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Snapshot"};
                  }],
                }
            })
            .state("viewPortfolio",
            {
                url: "/portfolioOverview?accountId",
                templateUrl: "assets/templates/PortfolioSummary/portfolioOverview.html",
                controller: 'portfolioViewCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Portfolio Overview"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("comparePortfolios",
            {
                url: "/comparePortfolios",
                templateUrl: "assets/templates/PortfolioSummary/compare.html",
                controller: 'portfolioCompareCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Portfolio Compare"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("stockReport",
            {
                url: "/stockReport?secId",
                templateUrl: "assets/templates/PortfolioSummary/stockReport.html",
                controller: 'stockReportCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Stock Report"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("fundReport",
            {
                url: "/fundReport?secId",
                templateUrl: "assets/templates/PortfolioSummary/fundReport.html",
                controller: 'fundReportCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Fund Report"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("etfReport",
            {
                url: "/etfReport?secId",
                templateUrl: "assets/templates/PortfolioSummary/etfReport.html",
                controller: 'etfReportCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "ETF Report"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("holdings",
            {
                url: "/holdings",
                templateUrl: "assets/templates/PortfolioSummary/holdings.html",
                controller: 'holdingsCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Holdings"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                },
                params: {
                    accountId: null,
                    autoDownloadPDF: null,
                    asAt: null
                }
            })
            .state('incomeProjection', {
                url: '/incomeProjection',
                templateUrl: 'assets/templates/PortfolioSummary/IncomeProjection.html'
            })
            .state('confirmationNotes', {
                url: '/confirmationNotes',
                templateUrl: 'assets/templates/portfolioSummary/confirmationNotes.html',
                controller: "confirmationNotesCtrl",
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Confirmation Notes"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state('marketOrders', {
                url: '/marketOrders',
                templateUrl: 'assets/templates/PortfolioSummary/marketOrders.html',
                controller: "marketOrdersCtrl",
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Market Orders"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("placeOrderRequest",
            {
                url: "/placeOrderRequest",
                templateUrl: "assets/templates/portfolioSummary/placeOrderRequest.html",
                controller: "placeOrderRequestViewCtrl",
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Place Order Request"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("viewOrderRequests",
            {
                url: "/viewOrderRequests",
                templateUrl: "assets/templates/portfolioSummary/viewOrderRequests.html",
                controller: "viewOrderRequestsViewCtrl",
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "View Order Requests"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("report",
            {
                url: "/report",
                templateUrl: "assets/templates/portfolioSummary/reports.html",
                controller: 'reportViewCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Accolade Reports"};
                    }],
                },
                params: {
                    hasAccoladeAccounts: null,
                    collapsedBanner: null,
                },
            })
            .state("report.quarterly",
            {
                url: "/quarterly",
                templateUrl: "assets/templates/portfolioSummary/reports.html",
                controller: 'reportViewCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Accolade Quarterly Reports"};
                    }],
                },
                params: {
                    hasAccoladeAccounts: null,
                },
            })
            .state("report.tax",
            {
                url: "/tax",
                templateUrl: "assets/templates/portfolioSummary/reports.html",
                controller: 'reportViewCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Accolade Tax Reports"};
                    }],
                },
                params: {
                    hasAccoladeAccounts: null,
                },
            })
            .state("report.invoices",
            {
                url: "/invoices",
                templateUrl: "assets/templates/portfolioSummary/reports.html",
                controller: 'reportViewCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Accolade Invoices"};
                    }],
                },
                params: {
                    hasAccoladeAccounts: null,
                },
            })
            .state("marketDepth",
            {
                url: "/marketDepth",
                templateUrl: "assets/templates/portfolioSummary/marketDepth.html",
                controller: 'marketDepthCtrl',
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Market Depth"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("ledger",
            {
                url: "/ledger",
                templateUrl: "assets/templates/portfolioSummary/ledger.html",
                controller: "ledgerViewCtrl",
                resolve: {
                    meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = {title: "Ledger"};
                    }],
                    checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        const profile = sessionService.getCurrentUserProfile()
                        if(profile){
                            deferred.resolve();
                        }else{
                            deferred.reject();
                        }

                        return deferred.promise;
                    }]
                }
            })
            .state("uatxray",
                {
                    url: "/uatxray",
                    templateUrl: "assets/templates/portfolioSummary/uat_xray.html",
                    controller: "xrayCtrl",
                    resolve: {
                        checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                            var deferred = $q.defer();
                            const profile = sessionService.getCurrentUserProfile()
                            if (profile) {
                                deferred.resolve();
                            } else {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }]
                    }
                })
            .state("uatportfoliocompare",
                {
                    url: "/uatportfoliocompare",
                    templateUrl: "assets/templates/portfolioSummary/uat_portfolioCompare.html",
                    controller: "uatPortfolioCompareCtrl",
                    resolve: {
                        checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                            var deferred = $q.defer();
                            const profile = sessionService.getCurrentUserProfile()
                            if (profile) {
                                deferred.resolve();
                            } else {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }]
                    }
                })
    }]);

portfolioModule.controller('portfolioBaseCtrl', Patersons.PortfolioBaseCtrl);
portfolioModule.controller('portfolioDashboardCtrl', Patersons.PortfolioDashboardCtrl);
portfolioModule.controller('portfolioHeatmapCtrl', Patersons.PortfolioHeatmapCtrl);
portfolioModule.controller('portfolioSnapshotCtrl', Patersons.PortfolioSnapshotCtrl);
portfolioModule.controller('portfolioViewCtrl', Patersons.PortfolioViewCtrl);
portfolioModule.controller('portfolioCompareCtrl', Patersons.PortfolioCompareCtrl);
portfolioModule.controller('stockReportCtrl', Patersons.StockReportCtrl);
portfolioModule.controller('fundReportCtrl', Patersons.FundReportCtrl);
portfolioModule.controller('etfReportCtrl', Patersons.EtfReportCtrl);
portfolioModule.controller('holdingsCtrl', Patersons.HoldingsCtrl);
portfolioModule.controller('confirmationNotesCtrl', Patersons.ConfirmationNotesCtrl);
portfolioModule.controller('marketOrdersCtrl', Patersons.MarketOrdersCtrl);
portfolioModule.controller('placeOrderRequestViewCtrl', Patersons.PlaceOrderRequestViewCtrl);
portfolioModule.controller('viewOrderRequestsViewCtrl', Patersons.ViewOrderRequestsViewCtrl);
portfolioModule.controller('reportViewCtrl', Patersons.ReportViewCtrl);
portfolioModule.controller('ledgerViewCtrl', Patersons.LedgerViewCtrl);
portfolioModule.controller('marketDepthCtrl', Patersons.MarketDepthCtrl);

portfolioModule.controller('xrayCtrl', Patersons.XrayCtrl);
portfolioModule.controller('uatPortfolioCompareCtrl', Patersons.UATPortfolioCompareCtrl);


portfolioModule.component('investorDocs', new Patersons.InvestorDocsComponent());
portfolioModule.component('reportTypeSelect', new Patersons.ReportTypeSelectComponent());
portfolioModule.component('accountDateRangeFilter', new Patersons.AccountDateRangeFilterComponent());
portfolioModule.component('portfolioSummary', new Patersons.PortfolioSummaryComponent());
portfolioModule.component('incomeReport', new Patersons.IncomeReportComponent());
portfolioModule.component('cashReport', new Patersons.CashReportComponent());
portfolioModule.component('capitalTransactionStatement', new Patersons.CapitalTransactionStatementComponent());
portfolioModule.component('standardLedgerReport', new Patersons.StandardLedgerReportComponent());
portfolioModule.component('performanceReport', new Patersons.PerformanceReportComponent());
portfolioModule.component('portfolioGraph', new Patersons.PortfolioGraphComponent());
portfolioModule.component('realisedCapitalGainsReport', new Patersons.RealisedCapitalGainsReportComponent());
portfolioModule.component('unrealisedCapitalGainsReport', new Patersons.UnrealisedCapitalGainsReportComponent());
portfolioModule.component('valuationReport', new Patersons.ValuationStatementComponent());
portfolioModule.component('marketValueReport', new Patersons.MarketValueReportComponent());
portfolioModule.component('reportDisclaimer', new Patersons.ReportDisclaimerComponent());
portfolioModule.component('holdingsDisclaimer', new Patersons.HoldingsDisclaimerComponent());
portfolioModule.component('cashHoldingsReport', new Patersons.CashHoldingsReportComponent());
portfolioModule.component('cashHighInterestHoldingsReport', new Patersons.CashHighInterestHoldingsReportComponent());
portfolioModule.component('termDepositsHoldingsReport', new Patersons.TermDepositsHoldingsReportComponent());
portfolioModule.component('equityHoldingsReport', new Patersons.EquityHoldingsReportComponent());
portfolioModule.component('totalMarketValue', new Patersons.TotalMarketValueComponent());
portfolioModule.component('portfolioNavigation', new Patersons.PortfolioNavigationComponent());
